import { useState } from "react";

import { useAppSelector } from "hooks/store";
import { getUserState } from "store/slices/Auth/authSlice";
import { BlocksType } from "store/slices/UserLimit/userLimitSlice";
import { TierType } from "types/users";

export const useModalLimit = (blockVariant: keyof BlocksType) => {
  const { data: userLimits } = useAppSelector((state) => state.userLimit);
  const { tier } = useAppSelector(getUserState);

  const [modalLimit, setModalLimit] = useState<boolean>(false);

  const isBlocked = userLimits && userLimits[blockVariant] === true && tier === TierType.Free;

  const handleOpenModalLimit = () => {
    setModalLimit(true);
  };

  const handleCloseModalLimit = () => {
    setModalLimit(false);
  };

  return { isBlocked, modalLimit, handleOpenModalLimit, handleCloseModalLimit };
};
